import { render, staticRenderFns } from "./PromotionVariable.vue?vue&type=template&id=4238ad08&scoped=true"
import script from "./PromotionVariable.vue?vue&type=script&lang=js"
export * from "./PromotionVariable.vue?vue&type=script&lang=js"
import style0 from "./PromotionVariable.vue?vue&type=style&index=0&id=4238ad08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238ad08",
  null
  
)

export default component.exports